import { COLOR_LINK } from 'constants/colors';
import styled from 'styled-components';

export const DetailsButton = styled.button`
  background: transparent;
  font-size: 0.875rem;
  color: ${COLOR_LINK};
  outline: none;
  border: none;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;

export const MainContainer = styled.div`
  display: flex;

  & > * {
    flex: 1;
  }
`;
